import React, { useState } from 'react'
import {
  Box,
  Button,
  FormControl,
  Grid,
  Modal,
  TextField,
} from '@material-ui/core'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { insertIndigenousCommunities } from '../../../../../services/AsistenciaTecnica/create'
import swal from 'sweetalert'
import { updateIndigenousCommunities } from '../../../../../services/AsistenciaTecnica/put'

export const Modal272 = (props) => {
  const {
    open,
    setOpen,
    getIndigenousCommunitiesList,
    body,
    setBody,
    IdTechnicalAssistanceAnswer,
  } = props

  const GeneralDataSchema = Yup.object().shape({
    Description: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#./\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(100, 'Máximo 100 caracteres'),
  })

  const [loading, setLoading] = useState(false)
  const [errorDescription, setErrorDescription] = useState(false)

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdIndigenousCommunity: body.IdIndigenousCommunity || 0,
      IdTechnicalAssistanceAnswer:
        body.IdTechnicalAssistanceAnswer || IdTechnicalAssistanceAnswer,
      Description: body.Description || '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values)
    },
  })

  const saveForm = async (values) => {
    setLoading(true)
    let response
    if (Object.keys(body).length === 0) {
      response = await insertIndigenousCommunities(values)
    }
    if (Object.keys(body).length > 0) {
      response = await updateIndigenousCommunities(values)
    }

    if (response.Success) {
      swal({
        title: '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getIndigenousCommunitiesList()
      handleClose()
      setLoading(false)
    }
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
    setBody({})
  }
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Datos de la Comunidad Indígena</h1>
          </div>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Comunidad Indígena <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: 220 }}
                  value={formik.values.Description}
                  onChange={(e) => {
                    if (
                      e.target.value.match(
                        /[-():;,%#./\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                      ) ||
                      e.target.value === ''
                    ) {
                      setErrorDescription(false)
                      formik.setFieldValue('Description', e.target.value)
                    } else {
                      setErrorDescription(true)
                    }
                  }}
                  inputProps={{
                    maxLength: 100,
                  }}
                />
                {formik.errors.Description ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.Description}
                  </div>
                ) : null}
                {errorDescription ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    Caracteres especiales no aceptados
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid className="buttonsPYME">
              <Button className="cancelButton" onClick={handleClose}>
                Cancelar
              </Button>
              <Button
                className="confirmButton"
                type="button"
                onClick={validateFormStatus}
                disabled={loading}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
